import { useSelector } from 'react-redux';
import { trackEvent } from 'iclinic-trackings';

import { getUserInfo } from 'features/onlinePayment/state/config/register/selectors';

export const useEventTracking = () => {
  const userData = useSelector(getUserInfo);

  return async <T extends Record<string, unknown>>(
    event: string,
    properties: T,
  ) => {
    if (!userData?.profileId) {
      return;
    }

    await trackEvent(event, {
      iclinic_id: Number(userData.profileId),
      ...properties,
    }).catch((error) => error);
  };
};
